import { useMemo, useState } from "react"

export function useValues<T>(values: readonly T[]): [T, ...(() => void)[]] {
    const [value, setValue] = useState<T>(values[0])
    const setValueHandlers = useMemo<(() => void)[]>(
        () => values.map(v => () => setValue(v)),
        [values]
    )

    return useMemo(
        () => [value, ...setValueHandlers],
        [value, setValueHandlers]
    )
}
